import React, { useEffect, useState, useRef } from 'react'
import { compose } from 'redux'
import {
  Container, Card, Button,
  TabContent, TabPane,
  Nav, NavItem, NavLink
} from 'reactstrap'
import _ from 'lodash'
import classnames from 'classnames'

import PageTitle from 'components/Title/PageTitle'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import Lang from 'Lang/General'
import WithEmailTemplate from './actions/emailTemplates'
import WithCenter from './actions/center'
import SenderSettings from './components/senderSettings'
import EmailTemplate from './components/emailTemplate'

const EmaiConfig = props => {
  const emailEditorRef = useRef( null )
  const [ activeTab, updateActiveTab ] = useState( 0 )

  useEffect( () => {
    props.getEmailTemplates()
  }, [] )

  useEffect( () => {
    onLoad()
  }, [ props.emailTemplateContentJsonb ] )

  const saveDesign = async () => {
    if( emailEditorRef.current && emailEditorRef.current.editor ) {
      let tmp = _.cloneDeep( props.emailTemplates )
      await emailEditorRef.current.editor.saveDesign( async design => {
        tmp.content_jsonb = design
        await emailEditorRef.current.editor.exportHtml( html => {
          tmp.content_html = html.html
          if ( activeTab === 0 ) {
            props.updateEmailTemplate( tmp )
          } else {
            props.updateEmailTemplate( tmp )
          }
        })
      })
    }
  }

  const onLoad = () => {
    if( emailEditorRef.current && emailEditorRef.current.editor ) {
      emailEditorRef.current.editor.loadDesign( props.emailTemplateContentJsonb )
    }
  }

  return (
    <>
      <PageTitle
        heading={ Lang[ 'EMAIL_CONFIG' ][ props.data.languageReducer.userSettings.admin_panel_language ] }
        icon="pe-7s-mail icon-gradient bg-happy-itmeo" />
        <Card className="main-card mb-3 p-4">
          <Nav tabs={ true }>
            <NavItem>
              <NavLink
                href='javascript:void(0);'
                className={ classnames({ active: activeTab === 0 }) }
                onClick={ () => updateActiveTab( 0 ) }>
                { Lang[ 'EMAIL_TEMPLATE' ][ props.data.languageReducer.userSettings.admin_panel_language ] }</NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href='javascript:void(0);'
                className={ classnames({ active: activeTab === 1 }) }
                onClick={ () => updateActiveTab( 1 ) }>
                { Lang[ 'SENDER_SETTINGS' ][ props.data.languageReducer.userSettings.admin_panel_language ] }</NavLink>
            </NavItem>
          </Nav>
          <Container>
            <TabContent activeTab={ activeTab }>
              <TabPane tabId={ 0 }>
                <EmailTemplate 
                  { ...props }
                  emailEditorRef={ emailEditorRef }
                  selectedLanguage={ props.data.languageReducer.userSettings.admin_panel_language}
                  onLoad={ onLoad } />
              </TabPane>
              <TabPane tabId={ 1 }>
                <SenderSettings 
                  { ...props } 
                  selectedLanguage={ props.data.languageReducer.userSettings.admin_panel_language}
                />
              </TabPane>
            </TabContent>
            <Button
              color='primary'
              className='d-block ml-auto mt-3'
              onClick={ () => saveDesign() }>
              { Lang[ 'UPDATE' ][ props.data.languageReducer.userSettings.admin_panel_language ] }
            </Button>
          </Container>
        </Card>
      { ( props.onLoadCenter || props.onLoadEmailTemplate ) && <LoadingOverlay /> }
    </>
  )
}

export default compose(
  WithEmailTemplate,
  WithCenter
)( EmaiConfig )